module.exports = __webpack_public_path__ + "bed-bubble-friend-not-enough.3ca41482.png";